import * as React from 'react';

import Component, { ActivityIndicatorProps } from './ActivityIndicator';

/**
 * Loader indicator component.
 */
export const ActivityIndicator: React.FC<ActivityIndicatorProps> = (props) => {
	return <Component {...props} />;
};
